import { render, staticRenderFns } from "./SDCampaignRequestContact.vue?vue&type=template&id=9892dd96&scoped=true"
import script from "./SDCampaignRequestContact.vue?vue&type=script&lang=js"
export * from "./SDCampaignRequestContact.vue?vue&type=script&lang=js"
import style0 from "./SDCampaignRequestContact.vue?vue&type=style&index=0&id=9892dd96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9892dd96",
  null
  
)

export default component.exports